/**
 * `#RGB` / `#RRGGBB` → an `rgba(r, g, b, alpha)` string.
 *
 * Used to tint an agent's identity colour (`colorForAgent`, a hex from common-lib's shared
 * `AGENT_OPTIONS`) for the brief bubble border — native draws `colorForAgent(id).opacity(0.5)`, and
 * a CSS border needs the alpha baked into the colour. The agent accents are the design-system source
 * of truth, so this is a computed token value, not a hand-picked literal. Falls back to the input
 * string unchanged if it isn't a hex we recognise.
 */
export function hexToRgba(hex: string, alpha: number): string {
  const m = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.exec(hex.trim());
  if (!m) return hex;
  let h = m[1];
  if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
